const position = {
  position: "fixed",
  right: "5%",
  bottom: "5%",
  zIndex: "100000",
};

export default position;
